import { LocaleBundle } from "../types";

const es: LocaleBundle = {
  "ui": {
    "nav": {
      "features": "Funciones",
      "pricing": "Precios",
      "integrations": "Integraciones",
      "industries": "Sectores",
      "apiDocs": "Documentación de la API",
      "about": "Acerca de",
      "customers": "Clientes",
      "contact": "Contacto",
      "login": "Iniciar sesión",
      "getFreeCRM": "Obtener FreeCRM",
      "openMenu": "Abrir menú",
      "language": "Idioma"
    },
    "hero": {
      "badge": "El CRM multicanal: correo electrónico, voz y SMS",
      "titleStart": "El CRM diseñado para ",
      "titleHighlight": "equipos de ventas multicanal",
      "subtitle": "Llega a cada cliente dondequiera que esté — con marketing por correo electrónico, voz y SMS integrados en una sola plataforma. Sin complementos, sin precios de nivel empresarial.",
      "cta": "Empieza gratis — no se necesita tarjeta",
      "pills": [
        "Marketing por correo electrónico",
        "Voz y llamadas",
        "SMS bidireccionales"
      ],
      "iosApp": "Aplicación para iOS",
      "androidApp": "Aplicación para Android",
      "heroAlt": "Panel de FreeCRM que muestra el pipeline de ofertas y la gestión de contactos"
    },
    "logos": {
      "trustedBy": "Con la confianza de más de 25,000 equipos en crecimiento"
    },
    "features": {
      "eyebrow": "Funciones",
      "title": "Un único CRM. Todos los canales que utilizan tus clientes.",
      "subtitle": "Marketing por correo electrónico, voz y SMS en una sola plataforma — para que tu equipo pueda llegar a los prospectos como prefieran.",
      "items": [
        {
          "title": "Marketing por correo electrónico",
          "desc": "Diseña campañas, envía difusiones y nutre leads con secuencias — todo desde el mismo registro de contacto."
        },
        {
          "title": "Voz y llamadas",
          "desc": "Click-to-call, registro de llamadas y grabación integrados. Conecta tu número y empieza conversaciones al instante."
        },
        {
          "title": "SMS bidireccionales",
          "desc": "Envía mensajes de texto a leads y clientes desde la misma bandeja de entrada. Incluye plantillas, envíos programados e historial completo de conversaciones."
        },
        {
          "title": "Secuencias multicanal",
          "desc": "Mezcla correo electrónico, SMS y llamadas en una sola cadencia. Llega a cada prospecto en el canal al que realmente responden."
        },
        {
          "title": "Análisis unificado",
          "desc": "Rastrea aperturas, clics, respuestas, conexiones y conversiones en todos los canales en un único panel."
        },
        {
          "title": "Automatización",
          "desc": "Inscribe automáticamente leads en campañas, rótalos entre representantes y activa seguimientos basados en cualquier señal."
        }
      ]
    },
    "testimonials": {
      "eyebrow": "Clientes",
      "title": "Con la confianza de equipos de ventas multicanal",
      "items": [
        {
          "quote": "Reemplazamos tres herramientas — marketing por correo electrónico, marcador y CRM — con FreeCRM. Nuestro equipo ahora ejecuta campañas por correo electrónico, SMS y llamadas desde un solo lugar.",
          "name": "Maya Chen",
          "role": "VP de Ventas, B2B SaaS"
        },
        {
          "quote": "Las secuencias multicanal lo cambiaron todo. Mezclar correo electrónico, SMS y una llamada en una sola cadencia duplicó nuestra tasa de respuesta sin añadir personal.",
          "name": "Daniel Okafor",
          "role": "Director de Ventas, Apex Solutions"
        },
        {
          "quote": "Cambíamos de HubSpot a FreeCRM y finalmente obtuvimos marketing por correo electrónico, voz y SMS en una sola plataforma — con cero costes de integración.",
          "name": "Priya Raman",
          "role": "COO, Brightline"
        }
      ]
    },
    "pricing": {
      "eyebrow": "Precios",
      "title": "Precios del software CRM",
      "subtitle": "Números de teléfono de EE. UU. solo $1.15/mes · $0.01 por minuto · $0.01 por SMS",
      "mostPopular": "Más popular",
      "perUserMo": "/usuario/mes",
      "tiers": [
        {
          "name": "Gratis",
          "price": "$0",
          "blurb": "Gratis para siempre con correo electrónico, voz y SMS integrados.",
          "cta": "Registrarse gratis"
        },
        {
          "name": "Pro",
          "price": "$10",
          "blurb": "Todo el poder del CRM para equipos de ventas en crecimiento.",
          "cta": "Registrarse"
        },
        {
          "name": "Enterprise",
          "price": "$25",
          "blurb": "Funciones avanzadas para equipos de alto volumen.",
          "cta": "Registrarse"
        }
      ],
      "sharedFeatures": [
        "Almacenamiento ilimitado",
        "Contactos y empresas",
        "Tratos y tareas",
        "Casos y llamadas",
        "Calendario y documentos",
        "Informes",
        "Aplicaciones iOS y Android",
        "Campañas y formularios",
        "Correo electrónico",
        "Acceso a la API",
        "Sincronización con Google",
        "QuickBooks",
        "SMS",
        "Llamadas de voz",
        "Tarjeta de crédito"
      ]
    },
    "faq": {
      "eyebrow": "Preguntas frecuentes",
      "title": "Preguntas, respondidas",
      "items": [
        {
          "q": "¿FreeCRM es realmente gratis para correo electrónico, voz y SMS?",
          "a": "Sí — el plan Gratuito incluye marketing por correo electrónico, llamadas con un clic, registro de llamadas y 500 mensajes SMS al mes sin costo. Los planes de pago desbloquean límites de envío más grandes, automatización avanzada, grabación de llamadas y SMS ilimitados."
        },
        {
          "q": "¿En qué se diferencia FreeCRM de HubSpot?",
          "a": "A diferencia de HubSpot, todos los canales son nativos — marketing por correo electrónico, voz y SMS están incluidos, no se venden como complementos separados o integraciones costosas."
        },
        {
          "q": "¿Puedo ejecutar campañas y secuencias de correo electrónico?",
          "a": "Sí. Diseña difusiones, campañas de goteo y secuencias de varios pasos que mezclan correo electrónico, SMS y llamadas — con seguimiento completo de aperturas, clics y respuestas."
        },
        {
          "q": "¿Puedo portar mis números de teléfono existentes?",
          "a": "Absolutamente. Puedes traer tus propios números o comprar números locales directamente dentro de FreeCRM en los planes Growth y Enterprise."
        },
        {
          "q": "¿Soportan SMS bidireccionales?",
          "a": "Sí. Envía y recibe SMS desde la misma bandeja de entrada que tu correo electrónico, con plantillas, envíos programados e historial completo de conversaciones por contacto."
        }
      ]
    },
    "cta": {
      "title1": "Correo electrónico, voz y SMS en un solo CRM.",
      "title2": "Llega a los clientes en cada canal.",
      "subtitle": "Únete a más de 25,000 equipos que usan FreeCRM para marketing por correo electrónico, voz y SMS — todo en una plataforma multicanal gratuita.",
      "button": "Empezar gratis"
    },
    "footer": {
      "tagline": "El CRM gratuito que crece con tu negocio.",
      "copyright": "Todos los derechos reservados.",
      "tagBuiltFor": "Construido para equipos que merecen algo mejor que HubSpot.",
      "cols": {
        "product": "Producto",
        "company": "Empresa",
        "resources": "Recursos",
        "legal": "Legal"
      },
      "links": {
        "features": "Funciones",
        "pricing": "Precios",
        "integrations": "Integraciones",
        "industries": "Sectores",
        "changelog": "Registro de cambios",
        "about": "Acerca de",
        "customers": "Clientes",
        "careers": "Carreras profesionales",
        "contact": "Contacto",
        "blog": "Blog",
        "helpCenter": "Centro de ayuda",
        "apiDocs": "Documentación de la API",
        "community": "Comunidad",
        "privacy": "Privacidad",
        "terms": "Términos",
        "security": "Seguridad",
        "dpa": "DPA"
      }
    },
    "contentPage": {
      "readyToStart": "¿Listo para empezar?",
      "joinThousands": "Únete a miles de equipos que utilizan FreeCRM para impulsar el marketing por correo electrónico, voz, SMS y embudo de ventas.",
      "defaultCta": "Empieza gratis — no se necesita tarjeta",
      "learnMore": "Aprender más →"
    },
    "languageNames": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português",
      "it": "Italiano", "de": "Deutsch", "ar": "العربية"
    }
  },
  "featurePages": {
    "calling": {
      "title": "Llamadas integradas",
      "eyebrow": "Característica",
      "description": "Click-to-call, llamadas desde el navegador, números virtuales, grabación y el marcador avanzado — todo integrado en FreeCRM.",
      "intro": "Las soluciones de CRM para centros de llamadas de FreeCRM automatizan las llamadas entrantes y salientes en 90 países. Obtén un número virtual — o usa tu propio móvil — y empieza a marcar desde cualquier registro de contacto.",
      "sections": [
        {
          "heading": "Click-to-call desde cualquier lugar",
          "body": "Descubre por qué somos el CRM gratuito número 1 para automatización de la fuerza de ventas, marketing y atención al cliente — con llamadas click-to-call desde el navegador a cualquier número de teléfono, desde cualquier contacto, trato o registro de empresa."
        },
        {
          "heading": "Grabación, programación y llamadas grupales",
          "body": "Graba llamadas para capacitación y cumplimiento normativo, programa seguimientos, organiza llamadas grupales y envía SMS — todo desde dentro del CRM sin herramientas adicionales."
        },
        {
          "heading": "Marcador avanzado y scripts de llamada",
          "body": "Maximiza la efectividad con clientes y prospectos existentes. Los potentes scripts de llamada y la automatización impulsan resultados de ventas confiables, ayudándote a aumentar tus ingresos netos."
        },
        {
          "heading": "Campañas y seguimientos",
          "body": "Crea campañas de llamadas y SMS, automatiza llamadas y SMS, y organiza y programa tus seguimientos para que nada se pase por alto."
        }
      ]
    },
    "contacts": {
      "title": "Gestión de contactos y leads",
      "eyebrow": "Característica",
      "description": "Contactos ilimitados, campos personalizados e importación potente desde Outlook, Salesforce, HubSpot o Zoho.",
      "intro": "Los contactos son tus prospectos, leads y clientes — proveedores, socios, donantes. En FreeCRM, tus contactos son oro y los tratamos como tal.",
      "sections": [
        {
          "heading": "Personaliza todo",
          "body": "Añade tantos campos personalizados como necesites. Cada negocio necesita un CRM personalizado — con FreeCRM puedes personalizar hojas de contacto, formularios y cada parte del sistema."
        },
        {
          "heading": "Rastrea cada interacción",
          "body": "Rastrea y gestiona relaciones, llamadas y reuniones. Asocia documentos, notas de reuniones y llamadas, y otra información importante con las personas para las que trabajas y con las que trabajas."
        },
        {
          "heading": "B2B, B2C y más",
          "body": "Los contactos son individuos que pueden pertenecer a empresas u otras organizaciones. Soportamos B2B, B2C y modelos de negocio más complejos."
        },
        {
          "heading": "Importa desde cualquier lugar",
          "body": "Importa listas de contactos desde cualquier archivo de hoja de cálculo, Outlook, Salesforce, HubSpot, Zoho o cualquier otro software de gestión de contactos."
        }
      ]
    },
    "companies": {
      "title": "Empresas y cuentas",
      "eyebrow": "Característica",
      "description": "Rastrea organizaciones, proveedores y socios con campos personalizados, listas e historial de actividad compartido.",
      "intro": "La lista de Empresas de FreeCRM proporciona un seguimiento organizacional robusto y flexible para cualquier entidad — B2B, B2C, sin fines de lucro o gubernamental — con campos completamente personalizables.",
      "sections": [
        {
          "heading": "Organiza y comparte",
          "body": "Organiza por categoría, estado, prioridad o filtros personalizados. Importa y exporta listas al instante, crea listas ilimitadas y comparte información organizacional en todo tu equipo."
        },
        {
          "heading": "Toda la actividad en un solo lugar",
          "body": "Las llamadas de ventas, los tickets de problemas y las actividades de los clientes se rastrean e informan. Las campañas de correo electrónico y el seguimiento de la automatización de llamadas se organizan por empresa."
        },
        {
          "heading": "¿Por qué las empresas?",
          "body": "Al rastrear las empresas con las que haces negocios, tus equipos pueden orquestar campañas de ventas más efectivas e identificar y compartir oportunidades en toda tu organización."
        }
      ]
    },
    "deals": {
      "title": "Pipeline de ventas",
      "eyebrow": "Característica",
      "description": "Pipeline de ventas visual, seguimiento de etapas, pronósticos e informes — diseñado para equipos de ventas salientes.",
      "intro": "Las ofertas son la razón por la que estás aquí. El conjunto de funciones de Ofertas de FreeCRM te permite gestionar y rastrear leads, aplicando una sólida metodología de ventas para llevar tu negocio al siguiente nivel.",
      "sections": [
        {
          "heading": "Seguimiento de etapas",
          "body": "Las ofertas se rastrean a través del estado — cotización, presupuesto, orden de compra, factura, comisión — para que siempre sepas en qué situación se encuentra cada oportunidad."
        },
        {
          "heading": "Informes y pronósticos",
          "body": "El pipeline proporciona tablas, informes y gráficos que muestran el rendimiento de tu equipo de ventas y campañas. Cuantifica el éxito a lo largo del tiempo e identifica nuevas oportunidades dentro de clientes nuevos o existentes."
        },
        {
          "heading": "Colaboración en equipo",
          "body": "El seguimiento de ofertas aporta cohesión a las personas que apoyan tus ventas. Servicios y Soporte pueden colaborar durante todo el ciclo para demostrar y lograr el éxito del equipo."
        }
      ]
    },
    "tasks": {
      "title": "Gestión de tareas",
      "eyebrow": "Característica",
      "description": "Prioriza, asigna y rastrea tareas con flujo de trabajo y estado — en tratos, contactos y casos.",
      "intro": "El seguimiento de tareas, problemas y ventas te brinda visibilidad completa del tiempo que tú y tu equipo dedican a cada trato o problema.",
      "sections": [
        {
          "heading": "¡Asigna la tarea!",
          "body": "Prioriza tareas, crea tipos de tareas personalizadas específicas para tu negocio, asigna tareas a miembros del equipo o empleados, dales flujo de trabajo y estado, y delega la carga de trabajo en todo tu equipo."
        },
        {
          "heading": "Un mejor delegador",
          "body": "Como puedes asignar tareas, te conviertes instantáneamente en un mejor delegador sin perder visibilidad de la calidad y el servicio que ofrece tu equipo."
        }
      ]
    },
    "cases": {
      "title": "Gestión de casos",
      "eyebrow": "Característica",
      "description": "Abre tickets, dirige problemas, personaliza estados y prioridades, y resuelve cada caso de cliente.",
      "intro": "El seguimiento de casos y problemas proporciona una visibilidad del 100% sobre los problemas que atiendes para clientes, proveedores y socios.",
      "sections": [
        {
          "heading": "Mesa de ayuda virtual",
          "body": "Inicia un nuevo caso y abre un ticket en tu mesa de ayuda virtual. Asocia casos a largo plazo con problemas continuos que se pueden resolver y cerrar rápidamente."
        },
        {
          "heading": "Personaliza para tu equipo",
          "body": "Personaliza problemas de soporte con campos personalizados, asigna problemas a uno o varios miembros del equipo y rastrea cada caso para que ningún problema de cliente se pase por alto."
        },
        {
          "heading": "Conecta todo",
          "body": "Relaciona casos con empresas, contactos, llamadas, eventos o documentos. Añade notas a medida que avanza el problema y mantén toda la información en un caso conveniente."
        }
      ]
    },
    "campaigns": {
      "title": "Automatización de marketing",
      "eyebrow": "Característica",
      "description": "Campañas de correo electrónico y SMS, segmentación y automatización integradas en tu CRM.",
      "intro": "Crea listas de correo a partir de datos demográficos, preferencias e interacciones. Crea y ejecuta campañas de correo electrónico personalizadas en cuatro sencillos pasos.",
      "sections": [
        {
          "heading": "Personalizado a escala",
          "body": "El software de marketing por correo electrónico de CRM hace más que enviar correos masivos — construye secuencias personalizadas, gestiona listas específicas y haz seguimiento automáticamente."
        },
        {
          "heading": "Plantillas optimizadas para móviles",
          "body": "Plantillas de correo electrónico fácilmente personalizables que se adaptan a todos los dispositivos, incluyendo teléfonos móviles, tabletas y más."
        },
        {
          "heading": "SMS + correo electrónico juntos",
          "body": "Combina secuencias de correo electrónico y SMS. Interactúa con tus clientes como nunca antes y mantén todo en un solo lugar."
        }
      ]
    },
    "calendar": {
      "title": "Calendario de grupo",
      "eyebrow": "Característica",
      "description": "Calendario de equipo compartido con recordatorios por correo electrónico y SMS, totalmente integrado con contactos, ofertas y tareas.",
      "intro": "El calendario de grupo de FreeCRM es una excelente manera de gestionar y visualizar tu horario, las actividades diarias, semanales y mensuales de tu equipo, las reuniones con clientes y las llamadas.",
      "sections": [
        {
          "heading": "Nunca te pierdas un evento",
          "body": "Envía notificaciones por correo electrónico y SMS para que nadie tenga excusa para perderse un evento de nuevo."
        },
        {
          "heading": "Conectado a todo",
          "body": "Rastrea próximos eventos, establece recordatorios, crea tareas, introduce notas, adjunta archivos y asocia entradas del calendario con uno o más contactos. Asigna tareas a uno o más compañeros de trabajo."
        },
        {
          "heading": "Filtra por equipo o contacto",
          "body": "Visualiza eventos para toda la base de datos, un único contacto, tú mismo, un compañero de trabajo o varios miembros del equipo. Nunca estás a más de un clic de la historia o la información de contacto."
        }
      ]
    },
    "documents": {
      "title": "Gestión documental",
      "eyebrow": "Característica",
      "description": "Almacenamiento ilimitado de documentos, acceso móvil y archivos adjuntos por registro.",
      "intro": "Comparte documentos importantes con tu equipo y proporciona acceso instantáneo a todos tus archivos electrónicos. Sube un solo archivo o un directorio completo con un solo clic.",
      "sections": [
        {
          "heading": "Almacenamiento ilimitado",
          "body": "Nuestro servicio gratuito incluye almacenamiento ilimitado para todos los documentos importantes de tu equipo. Cada miembro puede tener su propio almacén de documentos y vincular archivos a cualquier registro."
        },
        {
          "heading": "Prioridad móvil",
          "body": "Accede a documentos desde nuestras aplicaciones de iOS y Android — abre el CRM móvil, busca un documento y envía SMS y correos electrónicos a prospectos al instante."
        },
        {
          "heading": "Centraliza los activos",
          "body": "Un lugar seguro y protegido para centralizar tus activos de documentos electrónicos. Tu equipo puede acceder a contratos, literatura de ventas y marketing, formularios estandarizados y más desde cualquier parte del mundo."
        }
      ]
    },
    "email": {
      "title": "Automatización de correo electrónico",
      "eyebrow": "Característica",
      "description": "Secuencias de correo electrónico personalizadas, listas segmentadas y segmentación basada en CRM.",
      "intro": "Crea listas de correo basadas en datos demográficos, preferencias e interacciones para mensajes dirigidos. Ahorra tiempo y aumenta la productividad en un 74% con las herramientas de correo electrónico adecuadas.",
      "sections": [
        {
          "heading": "Cuatro sencillos pasos",
          "body": "Crea y ejecuta campañas de correo electrónico personalizadas en cuatro sencillos pasos con el software CRM de marketing por correo electrónico."
        },
        {
          "heading": "Más que correo masivo",
          "body": "El marketing por correo electrónico de CRM ayuda a los equipos con mucho más que hacer seguimiento a los leads de ventas, enviar correos masivos o crear secuencias personalizadas."
        },
        {
          "heading": "Plantillas responsivas",
          "body": "Plantillas fácilmente personalizables que se adaptan a todos los dispositivos — teléfonos, tabletas y ordenadores de escritorio."
        }
      ]
    },
    "forms": {
      "title": "Formularios y encuestas",
      "eyebrow": "Característica",
      "description": "Formularios de asistente multipágina, scripts de llamada y encuestas que se integran directamente en el CRM.",
      "intro": "Los formularios son encuestas de preguntas y respuestas — y también pueden ser scripts de llamada que tu personal de ventas o soporte completa con prospectos en línea.",
      "sections": [
        {
          "heading": "Formularios de asistente",
          "body": "La creación de formularios y encuestas es fácil con nuestro creador de formularios, creando formularios de asistente multipágina fáciles de seguir y completar. Una vez terminado, se te proporcionará un enlace público para distribuir."
        },
        {
          "heading": "Comentarios de clientes y scripts internos",
          "body": "Utiliza formularios para obtener comentarios de clientes, cuestionarios para el personal y scripts de llamadas. Crea encuestas personalizadas para ventas, marketing y satisfacción del cliente."
        },
        {
          "heading": "Informes y exportación",
          "body": "Los resultados de los formularios web y las encuestas se integran en un sistema de informes, presentados como tablas. Exporta a Excel o CSV para análisis o importación de marketing."
        }
      ]
    }
  },
  "industryPages": {
    "callcenter": {
      "title": "FreeCRM para centros de llamadas",
      "eyebrow": "Sector",
      "description": "CRM para centros de llamadas con marcación integrada, grabación, scripting y SMS en 90 países.",
      "intro": "Automatiza las llamadas entrantes y salientes en 90 países de todo el mundo. Obtén un número de teléfono virtual y pon en marcha las funciones del centro de llamadas desde el primer momento.",
      "sections": [
        {
          "heading": "Todas tus llamadas, en un solo lugar",
          "body": "Llamadas click-to-call desde el navegador a cualquier número de teléfono. Obtén un número virtual o usa el tuyo móvil — FreeCRM lo hace todo."
        },
        {
          "heading": "Grabación y programación",
          "body": "Realiza grabaciones de llamadas, programa llamadas y llamadas grupales, y envía SMS desde cualquier dispositivo. Funcionalidades avanzadas para la automatización de centros de llamadas."
        },
        {
          "heading": "Scripts y automatización",
          "body": "Potentes scripts de llamadas y automatización impulsan resultados de ventas fiables. Crea scripts asignados y programados a los miembros del equipo; rastrea cada llamada y sus resultados en nuestro sistema rico en funciones."
        },
        {
          "heading": "Campañas y seguimiento",
          "body": "Crea campañas de llamadas y SMS, automatízalas y organiza los seguimientos para que tu equipo nunca pierda un punto de contacto."
        }
      ]
    },
    "insurance": {
      "title": "FreeCRM para seguros",
      "eyebrow": "Sector",
      "description": "Nube de CRM para seguros para agentes, originadores y servicios para rastrear clientes, pólizas y reclamaciones.",
      "intro": "El CRM para la industria de seguros ayuda a agentes, originadores y servicios a vender a consumidores y empresas y a rastrear todas las interacciones en la nube.",
      "sections": [
        {
          "heading": "Diseñado para agentes y aseguradoras",
          "body": "Ya seas un agente, asegurador, proveedor de servicios u otro profesional de seguros, podemos ayudarte con tus necesidades de CRM."
        },
        {
          "heading": "Pólizas, reclamaciones y clientes",
          "body": "Automatiza el seguimiento de clientes importantes, pólizas, reclamaciones y más con plantillas de seguros preconfiguradas que funcionan para B2C y B2B."
        },
        {
          "heading": "Diseñado para la retención",
          "body": "El CRM es fundamental en seguros debido a la complejidad de los productos, la necesidad de una comunicación continua y la importancia de la retención de clientes."
        }
      ]
    },
    "realestate": {
      "title": "FreeCRM para bienes raíces",
      "eyebrow": "Sector",
      "description": "Gestión de leads y propiedades para profesionales de bienes raíces residenciales y comerciales.",
      "intro": "FreeCRM es utilizado en todo el sector inmobiliario por todo tipo de profesionales — residenciales o comerciales, compra, venta, corretaje o gestión.",
      "sections": [
        {
          "heading": "Gestión de leads y propiedades",
          "body": "Simplifica la gestión de leads y propiedades en el sector residencial y comercial. A los agentes les encanta nuestro CRM — y también a los corredores y administradores de propiedades."
        },
        {
          "heading": "Lista de propiedades como ofertas",
          "body": "Usa la sección de Ofertas para listar propiedades — típicamente por dirección (por ejemplo, '100 Main Street'). Añade múltiples prospectos a una sola propiedad y utiliza el tablero de ventas o el pipeline para rastrear embudos."
        },
        {
          "heading": "Asociaciones de propietarios (HOA) y activos complejos",
          "body": "Los administradores de propiedades en residenciales, comerciales, multifamiliares, condominios de gran altura y HOA usan FreeCRM para gestionar cada aspecto de las operaciones."
        }
      ]
    },
    "dental": {
      "title": "FreeCRM para odontología",
      "eyebrow": "Sector",
      "description": "CRM compatible con HIPAA para dentistas, cirujanos orales y la comunidad dental especializada.",
      "intro": "Apoyamos a la industria dental con un CRM de vanguardia para dentistas, cirujanos orales y todos en la comunidad médica especializada — y proporcionamos certificación BAA para el cumplimiento de HIPAA.",
      "sections": [
        {
          "heading": "Con la confianza de miles de consultorios",
          "body": "Con miles de clientes dentales, FreeCRM gestiona los requisitos de cumplimiento de la odontología, la cirugía oral, los implantes dentales y las industrias adyaculares que manejan información del paciente."
        },
        {
          "heading": "Seguridad de datos",
          "body": "La seguridad de datos es la esencia de FreeCRM. Los servidores están alojados en AWS — que cumple con HIPAA — y proporcionamos certificados BAA para los consultorios que los necesiten."
        },
        {
          "heading": "Integra tu stack",
          "body": "Empieza rápidamente e intégrate con los principales sistemas de gestión de consultorios e imágenes utilizados en odontología."
        }
      ]
    },
    "hipaa": {
      "title": "CRM compatible con HIPAA",
      "eyebrow": "Cumplimiento",
      "description": "FreeCRM cumple con HIPAA desde hace más de una década — certificados BAA disponibles con Enterprise.",
      "intro": "Gestionar la información de salud del paciente es un desafío. FreeCRM lanzó HIPAACRM.com en 2014 — el primer CRM del mundo compatible con HIPAA — y sigue siendo líder en seguridad y rendición de cuentas.",
      "sections": [
        {
          "heading": "¿Necesitas un BAA?",
          "body": "Si necesitas un certificado de Adendum de Asociado Comercial (BAA) para garantizar el cumplimiento de HIPAA, podemos ayudarte. Se requiere nuestra edición Enterprise, pagada anualmente por asiento por adelantado ($300/usuario/año)."
        },
        {
          "heading": "Más allá de los consultorios médicos",
          "body": "No son solo los consultorios médicos — los ensayos clínicos, nutricionistas, terapeutas y cualquier negocio que maneje información de atención médica aprovechan nuestro soporte HIPAA."
        },
        {
          "heading": "Seguridad de vanguardia",
          "body": "12 años de experiencia en HIPAA, alojado en AWS, con la seguridad y la rendición de cuentas que necesita para la información de salud protegida."
        }
      ]
    },
    "insidesales": {
      "title": "FreeCRM para ventas internas e independientes",
      "eyebrow": "Sector",
      "description": "Aumenta la productividad en más del 30% con una automatización CRM simple diseñada para representantes internos e independientes.",
      "intro": "FreeCRM ayuda a los representantes de ventas independientes y a los equipos de ventas internas a aumentar la productividad con herramientas y paneles de automatización CRM simples.",
      "sections": [
        {
          "heading": "Más del 30% de productividad",
          "body": "Los representantes de ventas independientes pueden aumentar sus ventas en más del 30% simplemente rastreando contactos y empresas — y nuestras herramientas de automatización amplifican el impacto."
        },
        {
          "heading": "Rastrea cada interacción",
          "body": "Registra cada llamada, correo electrónico y reunión. Ten un registro claro de lo que se dijo y lo que debe suceder a continuación, prioriza tareas y haz seguimiento a tiempo."
        },
        {
          "heading": "Amigable para autónomos",
          "body": "Diseñado para la autonomía de los representantes independientes que representan a múltiples empresas. Gestiona tu propio horario y relaciones con los clientes desde cualquier lugar."
        }
      ]
    },
    "contractor": {
      "title": "FreeCRM para contratistas y constructores",
      "eyebrow": "Sector",
      "description": "Gestione acuerdos, subcontratistas, programación y alertas en tiempo real para Contratistas Generales (GC) y constructores comerciales.",
      "intro": "Contratistas, constructores, GC y proveedores de edificios comerciales utilizan FreeCRM fácilmente para gestionar acuerdos y múltiples terceros como subcontratistas.",
      "sections": [
        {
          "heading": "Gestión de leads",
          "body": "Rastrea leads, monitorea el progreso y prioriza los esfuerzos. Obtén información sobre el comportamiento de los leads para decidir cuáles perseguir."
        },
        {
          "heading": "Estimaciones y propuestas",
          "body": "Automatiza el proceso de estimación y propuesta con una base de datos centralizada de propuestas anteriores, estimaciones y datos de precios — ahorrando tiempo y mejorando la precisión."
        },
        {
          "heading": "Programación y alertas",
          "body": "Asigna rápidamente equipos e individuos con alertas en tiempo real por correo electrónico o SMS. Mantén a los subcontratistas y equipos coordinados."
        }
      ]
    },
    "professional": {
      "title": "FreeCRM para servicios profesionales",
      "eyebrow": "Sector",
      "description": "Gestión de clientes, cumplimiento y prestación de servicios para firmas de servicios profesionales.",
      "intro": "Las firmas de servicios profesionales utilizan FreeCRM para gestionar los datos de los clientes, rastrear las interacciones y ofrecer un mejor servicio desde cualquier lugar y en cualquier dispositivo.",
      "sections": [
        {
          "heading": "Mayor satisfacción del cliente",
          "body": "Una vista completa de la relación con el cliente — detalles de contacto, transacciones pasadas, preferencias de comunicación — conduce a una mayor satisfacción y lealtad."
        },
        {
          "heading": "Cumplimiento más fácil",
          "body": "Cumple con GDPR y requisitos similares con una ubicación central para almacenar y compartir documentación de cumplimiento, y transparencia sobre las fuentes de datos del cliente."
        },
        {
          "heading": "Haz crecer la firma",
          "body": "El CRM de hoy debe ser accesible desde cualquier lugar, en cualquier dispositivo, en cualquier idioma — con inteligencia social y de mejores prácticas integrada para ayudarte a moverte más rápido."
        }
      ]
    }
  },
  "integrationPages": {
    "google": {
      "title": "FreeCRM + Google Workspace",
      "eyebrow": "Integración",
      "description": "Sincroniza Gmail, Google Calendar y Google Contacts con FreeCRM en un solo clic.",
      "intro": "Gmail y Google Workspace están profundamente integrados con FreeCRM. Conecta tu cuenta de Google y sincroniza correo electrónico, contactos y calendario.",
      "sections": [
        {
          "heading": "Configuración con un clic",
          "body": "Es sencillo añadir tu cuenta de Google — al igual que cualquier otra aplicación integrada con Google, es un inicio de sesión con un solo clic. También puedes usar tu cuenta de Google para iniciar sesión en FreeCRM."
        },
        {
          "heading": "Sincroniza lo que quieras",
          "body": "Una vez que añades Google a FreeCRM, elige si deseas sincronizar la cuenta completa o simplemente usar la funcionalidad de correo electrónico integrada. El Calendario y Google Contacts se incluyen cuando sincronizas."
        },
        {
          "heading": "Workspace se convierte en un CRM",
          "body": "Los sistemas CRM altamente integrados pueden convertir Google Workspace en un potente CRM que funciona con el alojamiento corporativo de Google o cualquier cuenta de Gmail."
        }
      ]
    },
    "quickbooks": {
      "title": "FreeCRM + QuickBooks",
      "eyebrow": "Integración",
      "description": "La integración de CRM con QuickBooks mejor valorada — Online y Desktop, sincronización bidireccional.",
      "intro": "La mejor integración de QuickBooks — calificada como la número 1 por los ProAdvisors de QuickBooks. El CRM para QuickBooks Online y Desktop simplifica las operaciones y te ayuda a aumentar las ventas.",
      "sections": [
        {
          "heading": "Estrechamente integrado",
          "body": "Si buscas una aplicación CRM estrechamente integrada con QuickBooks Online, FreeCRM es la solución perfecta."
        },
        {
          "heading": "Centraliza los datos del cliente",
          "body": "Un CRM que se integra con QuickBooks utiliza integraciones de software de contabilidad para almacenar y centralizar los datos de tus clientes en ventas y finanzas."
        },
        {
          "heading": "Online + Desktop",
          "body": "Ambos son compatibles: QuickBooks Online y QuickBooks Desktop."
        }
      ]
    },
    "zapier": {
      "title": "FreeCRM + Zapier",
      "eyebrow": "Integración",
      "description": "Conecta FreeCRM con más de 6,000 aplicaciones en Zapier — la forma más fácil de automatizar.",
      "intro": "Conecta instantáneamente el conector de FreeCRM con las aplicaciones que usas todos los días. FreeCRM se integra con otras 6,000 aplicaciones en Zapier — la forma más fácil de automatizar.",
      "sections": [
        {
          "heading": "Más de 6,000 aplicaciones",
          "body": "Desde Slack hasta Stripe y Google Sheets, envía y recibe datos de FreeCRM al resto de tu pila sin escribir código."
        },
        {
          "heading": "Automatización sin código",
          "body": "Crea Zaps para registrar llamadas, crear contactos, sincronizar ofertas y activar campañas cada vez que algo sucede en tus otras herramientas."
        }
      ]
    },
    "docusign": {
      "title": "FreeCRM + DocuSign",
      "eyebrow": "Integración",
      "description": "Envía, firma y rastrea acuerdos directamente desde tu CRM con la integración de DocuSign.",
      "intro": "DocuSign es la plataforma líder mundial para la firma de documentos. FreeCRM te permite optimizar los procesos al rellenar documentos con datos del CRM y actualizar el CRM desde los campos de DocuSign.",
      "sections": [
        {
          "heading": "Seguimiento en tiempo real",
          "body": "Solicita firmas y rastrea el estado del acuerdo en tiempo real. Ahorra tiempo con flujos de trabajo personalizados que activan acuerdos con un clic — y reduce errores."
        },
        {
          "heading": "Flujo de datos bidireccional",
          "body": "Automatiza flujos de trabajo completos, genera y envía contratos, y archiva documentos completados. Actualiza sistemas con datos de documentos o rellena documentos desde el CRM — funciona en ambos sentidos."
        }
      ]
    },
    "whatsapp": {
      "title": "FreeCRM + WhatsApp",
      "eyebrow": "Integración",
      "description": "Utiliza la API de WhatsApp Business para llamadas y mensajes de texto desde FreeCRM.",
      "intro": "WhatsApp y FreeCRM forman una poderosa combinación — utiliza la API de WhatsApp Business para llamadas y mensajes de texto, y automatiza la captura de leads y las comunicaciones.",
      "sections": [
        {
          "heading": "Comunicación optimizada",
          "body": "Gestiona las interacciones con los clientes de WhatsApp en una ubicación central para tiempos de respuesta más rápidos y mayor satisfacción."
        },
        {
          "heading": "Integración de datos de clientes",
          "body": "Incorpora los datos de los clientes de WhatsApp a FreeCRM y automatiza tareas repetitivas como el reenvío de mensajes, la priorización de respuestas y la entrada de datos."
        }
      ]
    },
    "aws": {
      "title": "FreeCRM en AWS",
      "eyebrow": "Infraestructura",
      "description": "Disponibilidad de seis nueves, ingenieros 24/7/365 y seguridad de datos de grado federal en Amazon AWS.",
      "intro": "FreeCRM opera en Amazon AWS con un objetivo de disponibilidad de seis nueves (99.9999%). Los ingenieros están de servicio 24/7/365.",
      "sections": [
        {
          "heading": "Instalaciones de grado federal",
          "body": "Nuestras instalaciones físicas cumplen o superan todos los requisitos federales e internacionales de seguridad de datos, redundancia, reanudación y continuidad del negocio."
        },
        {
          "heading": "Nube de la más alta calidad",
          "body": "Confía en nosotros para ofrecer los servicios en la nube de la más alta calidad disponibles en cualquier lugar — encriptados, monitoreados y continuamente disponibles."
        }
      ]
    }
  },
  "footerPages": {
    "features": {
      "title": "Todo lo que necesitas en un CRM",
      "eyebrow": "Funciones",
      "description": "Llamadas integradas, SMS, ofertas, contactos, tareas, casos, campañas, calendario, documentos, informes, API e integraciones — gratis para siempre.",
      "intro": "FreeCRM te ofrece contactos, empresas, ofertas, tareas, casos, llamadas, calendario, documentos, informes, campañas, formularios, correo electrónico, API e integraciones — todo en un solo lugar, gratis para siempre."
    },
    "pricing": {
      "title": "Precios",
      "description": "CRM gratis para siempre. Pro a $10/usuario/mes. Enterprise a $25/usuario/mes. Números de EE. UU. $1.15/mes, $0.01/min, $0.01/SMS."
    },
    "integrations": {
      "title": "Integraciones y aplicaciones conectadas",
      "eyebrow": "Integraciones",
      "description": "Conecta FreeCRM con Google, QuickBooks, Zapier, DocuSign, WhatsApp y más de 6,000 aplicaciones.",
      "intro": "FreeCRM se conecta con las herramientas que ya utilizas — Google Workspace, QuickBooks, Zapier, DocuSign, WhatsApp y miles más — para mantener tus datos sincronizados y tus flujos de trabajo automatizados."
    },
    "changelog": {
      "title": "Novedades en FreeCRM",
      "eyebrow": "Registro de cambios",
      "description": "Mejoras recientes, nuevas funciones y correcciones aplicadas a FreeCRM.",
      "intro": "Enviamos mejoras continuamente. Aquí están los aspectos más destacados de las últimas versiones.",
      "sections": [
        {
          "heading": "Mayo 2026 — Marcador avanzado 2.0",
          "body": "Marcación de presencia local más rápida, correo de voz inteligente y atajos de disposición de llamadas que reducen a la mitad el trabajo posterior a la llamada."
        },
        {
          "heading": "Abril 2026 — Nuevas aplicaciones para iOS y Android",
          "body": "Aplicaciones móviles completamente nuevas con soporte sin conexión, notificaciones push para llamadas y SMS entrantes, y acceso completo al pipeline desde tu teléfono."
        },
        {
          "heading": "Marzo 2026 — Sincronización bidireccional con QuickBooks",
          "body": "Clientes, facturas y pagos ahora se sincronizan bidireccionalmente entre FreeCRM y QuickBooks Online y Desktop."
        },
        {
          "heading": "Febrero 2026 — Entrenamiento de llamadas",
          "body": "Controles de escucha en vivo, susurro e intrusión para gerentes, además de puntuación de llamadas generada por IA en Enterprise."
        }
      ]
    },
    "about": {
      "title": "Acerca de FreeCRM",
      "eyebrow": "Empresa",
      "description": "Desde 2003, FreeCRM ha ofrecido el primer CRM completamente gratuito del mundo, siendo pionero en el modelo freemium para equipos de ventas, servicio y marketing.",
      "intro": "¿Por qué FreeCRM es gratis? Porque creemos en tu negocio. Hemos ofrecido el primer CRM completamente gratuito del mundo desde 2003 — y hemos ayudado a cientos de miles de empresas a crecer.",
      "sections": [
        {
          "heading": "¿Por qué gratis?",
          "body": "Te ofrecemos un CRM gratuito como una inversión en ti y en tu negocio. Sabemos que te ayudaremos a tener éxito y que, en algún momento en el futuro, quizás nos pagues. A medida que tus ventas crezcan, querrás más funciones — y Pro y Enterprise estarán ahí cuando estés listo."
        },
        {
          "heading": "Fuimos pioneros en el modelo freemium",
          "body": "FreeCRM fue pionero en el modelo freemium: software potente gratuito, con la opción de actualizar para SMS, llamadas de voz, QuickBooks, acceso avanzado a la API, Zapier y más."
        },
        {
          "heading": "Construido sobre AWS",
          "body": "Nos tomamos en serio la seguridad de los datos. FreeCRM se ejecuta en Amazon AWS con una disponibilidad objetivo de seis nueves (99.9999%). Los ingenieros están de servicio 24/7/365, y nuestras instalaciones cumplen o superan los requisitos federales e internacionales de seguridad de datos, redundancia y continuidad."
        },
        {
          "heading": "Integral por diseño",
          "body": "Un CRM robusto es una aplicación de trabajo integral que gestiona tanto las operaciones de front-office como las de back-office. FreeCRM es así de potente — y gratuito — cubriendo ventas, servicio, marketing, llamadas y operaciones en un solo lugar."
        }
      ]
    },
    "customers": {
      "title": "Los clientes aman FreeCRM",
      "eyebrow": "Clientes",
      "description": "Descubre cómo los equipos de ventas salientes, los centros de llamadas y las PYMES utilizan FreeCRM para realizar un 40% más de llamadas y cerrar acuerdos más rápido.",
      "intro": "Cientos de miles de equipos — desde startups de dos personas hasta centros de llamadas de 50 puestos — gestionan ventas y servicios con FreeCRM.",
      "sections": [
        {
          "heading": "Ventas internas — 40% más de llamadas",
          "body": "\"Nuestros SDR pasaron de 80 llamadas al día a más de 110 una vez que nos cambiamos a FreeCRM. El marcador avanzado y la función click-to-call dentro de la vista de contacto lo cambiaron todo.\" — VP de Ventas, B2B SaaS"
        },
        {
          "heading": "Centros de llamadas — reemplazó un stack de $18k/año",
          "body": "\"Reemplazamos nuestro marcador, CRM y herramientas de SMS con FreeCRM y ahorramos $18k al año — sin perder ni una sola función que a nuestros representantes les importara.\" — Director de Operaciones, Seguros"
        },
        {
          "heading": "PYMES — migró 50 puestos",
          "body": "\"Implementamos FreeCRM para 50 agentes en dos semanas. El aprovisionamiento de números locales y la grabación de llamadas estaban activos desde el primer día.\" — Jefe de Ingresos, Servicios a Domicilio"
        },
        {
          "heading": "Organización sin fines de lucro — gestión de donantes",
          "body": "\"FreeCRM nos permite tratar a los donantes como contactos y las promesas de donación como acuerdos. El precio es correcto, y las funciones de llamadas son un cambio de juego.\" — Director Ejecutivo, NPO"
        }
      ]
    },
    "careers": {
      "title": "Trabaja en FreeCRM",
      "eyebrow": "Carreras profesionales",
      "description": "Únete a un equipo remoto que construye el CRM gratuito más popular del mundo con llamadas y SMS integrados.",
      "intro": "Somos un equipo remoto que construye el CRM gratuito más popular del mundo. Si te gusta el software simple, la iteración rápida y los clientes que realmente usan lo que construyes, nos encantaría hablar contigo.",
      "sections": [
        {
          "heading": "Cómo trabajamos",
          "body": "Equipos pequeños, primero asíncrono, primero escrito. Enviamos cada semana. Contratamos perfiles senior, confiamos en que la gente se haga cargo de su trabajo y pagamos de forma competitiva en efectivo y acciones."
        },
        {
          "heading": "Puestos vacantes",
          "body": ""
        },
        {
          "heading": "Cómo aplicar",
          "body": "Envía un correo electrónico a careers@freecrm.com con el puesto que te interesa, una breve nota sobre el porqué y enlaces a tu trabajo. Respondemos a cada solicitud."
        }
      ],
      "roles": [
        "Ingeniero Full-stack Senior (React / Node)",
        "Ingeniero de Telefonía (WebRTC, SIP)",
        "Diseñador de Producto",
        "Éxito del Cliente — Ventas Outbound",
        "Ejecutivo de Cuentas — SMB"
      ]
    },
    "contact": {
      "title": "Contacto FreeCRM",
      "eyebrow": "Contacto",
      "description": "Habla con ventas, obtén soporte del producto o contacta con nuestros equipos de privacidad y seguridad.",
      "intro": "Estamos aquí para ayudarte. Ponte en contacto con el equipo adecuado a continuación — normalmente respondemos en un día hábil.",
      "sections": [
        {
          "heading": "Ventas",
          "body": "¿Quieres un recorrido por Pro o Enterprise, o ayuda para portar números y migrar desde HubSpot? Envía un correo electrónico a sales@freecrm.com."
        },
        {
          "heading": "Soporte",
          "body": "¿Eres cliente existente? Abre un ticket desde la aplicación o envía un correo electrónico a support@freecrm.com. Los clientes Pro y Enterprise obtienen respuesta prioritaria."
        },
        {
          "heading": "Privacidad y seguridad",
          "body": "Preguntas sobre privacidad: privacy@freecrm.com. Divulgaciones de seguridad: security@freecrm.com. Acusamos recibo de los informes en 24 horas."
        },
        {
          "heading": "Dirección postal",
          "body": "FreeCRM, Inc. — Comunicaciones con el Cliente — Delaware, EE. UU."
        }
      ]
    },
    "blog": {
      "title": "El blog de FreeCRM",
      "eyebrow": "Blog",
      "description": "Playbooks, análisis profundos de productos e historias de clientes para equipos de ventas salientes y centros de llamadas.",
      "intro": "Playbooks prácticos para ventas salientes, ventas internas y operaciones de centros de llamadas de PYMES — escritos por el equipo que construye FreeCRM.",
      "sections": [
        {
          "heading": "Cómo configurar un marcador avanzado en 10 minutos",
          "body": "Una guía paso a paso para aprovisionar números, importar una lista y ejecutar tu primera sesión de marcación avanzada dentro de FreeCRM."
        },
        {
          "heading": "5 formas en que FreeCRM supera a HubSpot en llamadas",
          "body": "Voz y SMS integrados, sin recargos por minuto, gratis para siempre — las funciones de llamadas dentro de FreeCRM comparadas con el Sales Hub de HubSpot."
        },
        {
          "heading": "De hojas de cálculo a un CRM en una tarde",
          "body": "Cómo importar contactos, configurar tu pipeline y empezar a rastrear acuerdos en FreeCRM en una sola tarde."
        },
        {
          "heading": "Construyendo un centro de llamadas de 50 puestos en FreeCRM",
          "body": "Cómo una empresa de servicios a domicilio implementó FreeCRM para 50 agentes en dos semanas — incluyendo el aprovisionamiento de números locales y la grabación de llamadas."
        }
      ]
    },
    "help": {
      "title": "Centro de ayuda",
      "eyebrow": "Recursos",
      "description": "Guías, tutoriales y respuestas para sacar el máximo provecho de FreeCRM.",
      "intro": "Busca guías y tutoriales, o navega por tema. Los clientes Pro y Enterprise también reciben soporte prioritario por correo electrónico.",
      "sections": [
        {
          "heading": "Primeros pasos",
          "body": "Crea tu cuenta, invita a tu equipo, importa contactos y configura tu pipeline. La mayoría de los equipos están activos en menos de una hora."
        },
        {
          "heading": "Llamadas y SMS",
          "body": "Aprovisiona números, configura click-to-call, graba llamadas, ejecuta el marcador avanzado y envía SMS gratuitos desde cualquier registro de contacto."
        },
        {
          "heading": "Pipelines y ofertas",
          "body": "Personaliza etapas, crea informes y pronósticos, y rastrea cada oferta desde la cotización hasta la factura."
        },
        {
          "heading": "Integraciones",
          "body": "Conecta Google, QuickBooks, Zapier, DocuSign y más de 6,000 aplicaciones. Sincroniza contactos, calendario, correo electrónico, facturas y más."
        },
        {
          "heading": "Administración y seguridad",
          "body": "Gestiona usuarios, roles, SSO, registros de auditoría y exportación de datos. Los clientes Enterprise también obtienen aprovisionamiento SCIM y un CSM dedicado."
        }
      ]
    },
    "apiDocs": {
      "title": "API de CRM",
      "eyebrow": "Documentación de la API",
      "description": "Una API REST basada en estándares para capturar leads, sincronizar datos y automatizar ventas y soporte entrantes dentro de FreeCRM.",
      "intro": "Aprovecha al máximo tu CRM y automatiza las ventas y el servicio al cliente entrantes. Nuestros servicios web API permiten que tu sitio web envíe y reciba datos directamente a FreeCRM.",
      "whatHeading": "Qué puedes hacer",
      "capturesHeading": "Captura leads del sitio web",
      "authHeading": "Autenticación",
      "webhooksHeading": "Webhooks",
      "rateLimitsHeading": "Límites de velocidad y SDKs",
      "sections": [
        {
          "heading": "Qué puedes hacer",
          "body": "Conecta formularios de sitios web, dirige correos electrónicos entrantes, abre casos de soporte, captura leads, y sincroniza datos con cualquier sistema externo. Utilizamos una API REST basada en estándares que es fácil de integrar desde cualquier tecnología."
        },
        {
          "heading": "Captura leads del sitio web",
          "body": "Añade nuestra plantilla de código a cualquier formulario web y comienza a capturar soporte al cliente y leads de ventas en tiempo real, directamente dentro de FreeCRM. Reduce el ruido de correo electrónico entrante y nunca pierdas un lead."
        },
        {
          "heading": "Webhooks",
          "body": "Suscríbete a eventos — contact.created, deal.updated, call.completed, sms.received — y envíalos a tus propios sistemas en tiempo real."
        },
        {
          "heading": "Límites de velocidad y SDKs",
          "body": "1,000 solicitudes / minuto en Pro, 5,000 / minuto en Enterprise. SDKs oficiales para Node y Python disponibles; las librerías de la comunidad cubren Ruby, PHP y Go."
        }
      ]
    },
    "community": {
      "title": "Comunidad de FreeCRM",
      "eyebrow": "Comunidad",
      "description": "Conéctate con miles de usuarios de FreeCRM, comparte playbooks y obtén respuestas del equipo.",
      "intro": "Únete a miles de usuarios de FreeCRM compartiendo playbooks, automatizaciones y mejores prácticas para ventas salientes y operaciones de centros de llamadas.",
      "sections": [
        {
          "heading": "Foros",
          "body": "Haz preguntas, comparte lo que funciona y aprende de equipos que usan FreeCRM de todos los tamaños — desde fundadores individuales hasta centros de llamadas de 50 puestos."
        },
        {
          "heading": "Slack y Discord",
          "body": "Canales en tiempo real para usuarios avanzados, administradores y desarrolladores que construyen sobre la API de FreeCRM. El equipo de producto también se encuentra allí."
        },
        {
          "heading": "Horas de oficina",
          "body": "Sesiones en vivo semanales que cubren la incorporación, el marcador avanzado, las integraciones y las nuevas funciones. Gratis para todos los clientes."
        }
      ]
    },
    "privacy": {
      "title": "Política de Privacidad",
      "eyebrow": "Legal",
      "description": "Política de privacidad de FreeCRM: tus datos son siempre privados y nunca se comparten con terceros.",
      "intro": "Tus datos son siempre privados. No compartimos datos de clientes con terceros.",
      "sections": [
        {
          "heading": "Recopilación y uso de información",
          "body": "Tus datos son 100% privados. No utilizamos los datos que introduces en el sistema para ningún propósito que no sea el soporte de tu CRM. Los datos que ingreses seguirán siendo propiedad exclusiva de las personas y organizaciones que los ingresaron. Estos datos nunca se comparten con organizaciones externas o terceros. En caso de adquisición, insolvencia, cambio de propiedad o cualquier cambio en la estructura corporativa, siempre nos aseguraremos de que tus datos permanezcan privados e intactos."
        },
        {
          "heading": "Qué recopilamos",
          "body": "Recopilamos la información de identificación personal necesaria para proporcionar el servicio: nombre, correo electrónico, teléfono, datos de facturación y los datos que elijas almacenar dentro de tu CRM. Recopilamos datos de registro y uso para operar, asegurar y mejorar el servicio."
        },
        {
          "heading": "Cómo usamos la información",
          "body": "Utilizamos la información para proporcionar y mejorar el servicio, comunicarnos contigo, ofrecer soporte, asegurar la plataforma y cumplir con las obligaciones legales. Nunca vendemos datos personales."
        },
        {
          "heading": "Compartir",
          "body": "No compartimos ni vendemos información del usuario. Contratamos subprocesadores de confianza (como nuestros proveedores de nube y telefonía) estrictamente para operar el servicio, bajo contratos que exigen confidencialidad y protección de datos."
        },
        {
          "heading": "Opciones y correcciones",
          "body": "Puedes acceder, corregir, exportar o eliminar tus datos en cualquier momento desde dentro de la aplicación, o contactando a privacy@freecrm.com."
        },
        {
          "heading": "Seguridad",
          "body": "FreeCRM opera en Amazon AWS con controles de seguridad física, de red y de aplicaciones estándar de la industria, cifrado en tránsito y en reposo, y monitoreo 24/7/365."
        },
        {
          "heading": "Contacto",
          "body": "¿Preguntas o inquietudes? Envía un correo electrónico a privacy@freecrm.com. Responderemos en un plazo razonable."
        }
      ]
    },
    "terms": {
      "title": "Términos de Servicio",
      "eyebrow": "Legal",
      "description": "El Acuerdo de Suscripción que rige tu uso del software y los servicios de FreeCRM.",
      "intro": "Al usar el software de FreeCRM, aceptas, en nombre de la entidad que licencia el software, estar obligado por este Acuerdo de Suscripción.",
      "sections": [
        {
          "heading": "1. Aceptación",
          "body": "Al hacer clic en “Acepto” o al usar el software FreeCRM que has seleccionado, aceptas en nombre de la entidad que licencia el software (“Compañía”) que la Compañía se convierte en parte de este Acuerdo y que tienes autoridad para vincular a la Compañía. Si la Compañía no está de acuerdo, no te registres ni uses el software."
        },
        {
          "heading": "2. Descripción del servicio",
          "body": "FreeCRM proporciona su servicio sujeto a estos Términos de Servicio, que pueden ser actualizados por nosotros de vez en cuando. La versión actual siempre se publica en esta URL. Las características particulares pueden estar sujetas a pautas adicionales publicadas, que se incorporan por referencia."
        },
        {
          "heading": "3. Tu cuenta",
          "body": "Eres responsable de mantener la confidencialidad de tus credenciales y de toda la actividad que ocurra bajo tu cuenta. Notifícanos inmediatamente cualquier uso no autorizado."
        },
        {
          "heading": "4. Uso aceptable",
          "body": "Aceptas no usar FreeCRM para enviar spam, acosar a otros, infringir la propiedad intelectual, distribuir malware o violar cualquier ley aplicable. Podemos suspender las cuentas que infrinjan estas reglas."
        },
        {
          "heading": "5. Tarifas",
          "body": "El plan Gratuito se ofrece sin cargo. Los planes Pro y Enterprise se facturan por adelantado de forma mensual o anual. El uso de la telefonía (números, minutos, SMS) se factura según las tarifas publicadas."
        },
        {
          "heading": "6. Propiedad de los datos",
          "body": "Conservas todos los derechos sobre los datos que ingresas en FreeCRM. Los procesamos únicamente para proporcionar y mejorar el servicio."
        },
        {
          "heading": "7. Terminación",
          "body": "Cualquiera de las partes puede rescindir en cualquier momento. Al rescindir, puedes exportar tus datos; después de un período razonable, podemos eliminarlos."
        },
        {
          "heading": "8. Exenciones de responsabilidad y limitación de responsabilidad",
          "body": "El servicio se proporciona \"tal cual\" sin garantías de ningún tipo. En la medida máxima permitida por la ley, la responsabilidad total de FreeCRM se limita a las tarifas pagadas en los doce meses anteriores a la reclamación."
        },
        {
          "heading": "9. Ley aplicable",
          "body": "Este Acuerdo se rige por las leyes del Estado de Delaware, EE. UU., sin tener en cuenta los principios de conflicto de leyes."
        }
      ]
    },
    "security": {
      "title": "Seguridad",
      "eyebrow": "Confianza",
      "description": "Cómo FreeCRM mantiene tus datos seguros — construido sobre Amazon AWS con cifrado, monitoreo 24/7 y estrictos controles de acceso.",
      "intro": "Nos tomamos en serio la seguridad de los datos. FreeCRM opera en Amazon AWS con una disponibilidad objetivo de seis nueves (99.9999%) e ingenieros de servicio 24/7/365.",
      "sections": [
        {
          "heading": "Infraestructura",
          "body": "FreeCRM se ejecuta en Amazon AWS. Nuestras instalaciones físicas cumplen o superan todos los requisitos federales e internacionales de seguridad de datos, redundancia, reanudación y continuidad del negocio."
        },
        {
          "heading": "Cifrado",
          "body": "Todos los datos se cifran en tránsito utilizando TLS 1.2+ y en reposo utilizando AES-256. Las copias de seguridad se cifran y almacenan en múltiples zonas de disponibilidad."
        },
        {
          "heading": "Controles de acceso",
          "body": "Acceso basado en roles dentro de la aplicación, principio de privilegio mínimo para el acceso a producción y registro de auditoría de acciones administrativas. Los clientes Enterprise obtienen SSO (SAML), aprovisionamiento SCIM y registros de auditoría completos."
        },
        {
          "heading": "Monitoreo y respuesta",
          "body": "Monitoreo 24/7/365 de la plataforma, alertas automatizadas y un equipo de ingeniería de guardia. Probamos las copias de seguridad regularmente y realizamos ejercicios periódicos de respuesta a incidentes."
        },
        {
          "heading": "Notificación de una vulnerabilidad",
          "body": "Envía un correo electrónico a security@freecrm.com con los detalles. Acusamos recibo de los informes en 24 horas y damos crédito a la divulgación responsable."
        }
      ]
    },
    "dpa": {
      "title": "Apéndice de Procesamiento de Datos (DPA)",
      "eyebrow": "Legal",
      "description": "El DPA rige cómo FreeCRM procesa datos personales en nombre de los clientes, de conformidad con GDPR y leyes similares.",
      "intro": "Este Apéndice de Procesamiento de Datos (DPA) complementa tu Acuerdo de Suscripción a FreeCRM y rige cómo procesamos datos personales en su nombre.",
      "sections": [
        {
          "heading": "1. Roles",
          "body": "Usted (Cliente) es el controlador de datos. FreeCRM actúa como procesador de datos y procesa datos personales únicamente según sus instrucciones documentadas, incluidas las transferencias, excepto cuando lo exija la ley aplicable."
        },
        {
          "heading": "2. Objeto y duración",
          "body": "Objeto: provisión del servicio FreeCRM. Duración: el término del Acuerdo más cualquier período de retención posterior a la terminación."
        },
        {
          "heading": "3. Subprocesadores",
          "body": "Contratamos subprocesadores verificados (incluido AWS para el alojamiento y nuestros proveedores de telefonía para voz y SMS). Una lista actual está disponible bajo petición. Notificamos a los clientes los cambios materiales."
        },
        {
          "heading": "4. Medidas de seguridad",
          "body": "Implementamos medidas técnicas y organizativas apropiadas al riesgo, incluido el cifrado en tránsito y en reposo, controles de acceso, registro, gestión de vulnerabilidades y capacitación del personal."
        },
        {
          "heading": "5. Derechos de los interesados",
          "body": "Le ayudamos a satisfacer las solicitudes de los interesados (acceso, rectificación, eliminación, portabilidad) a través de herramientas integradas en la aplicación y, cuando sea necesario, soporte."
        },
        {
          "heading": "6. Transferencias internacionales",
          "body": "Cuando los datos personales se transfieren fuera del EEE, el Reino Unido o Suiza, la transferencia se rige por Cláusulas Contractuales Estándar u otro mecanismo de transferencia legal."
        },
        {
          "heading": "7. Notificación de infracción",
          "body": "Le notificaremos sin demoras indebidas después de tener conocimiento de una infracción de datos personales que afecte a sus datos."
        },
        {
          "heading": "8. Auditorías",
          "body": "Con un preaviso razonable, pondremos a su disposición la información necesaria para demostrar el cumplimiento, incluidos los informes de auditorías de terceros cuando corresponda."
        }
      ]
    },
    "industriesIndex": {
      "title": "FreeCRM por sector",
      "eyebrow": "Sectores",
      "description": "Descubre cómo los equipos de centros de llamadas, seguros, bienes raíces, odontología, servicios profesionales y más usan FreeCRM.",
      "intro": "Plantillas y flujos de trabajo para los sectores que se ejecutan en FreeCRM."
    }
  }
};

export default es;
